import * as ActionTypes from '../ActionTypes';

const initialState = {
    offer_letter_id_data: {},
    isLoading: false,
};
const AtsOfferLetterIdReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ATS_OFFER_LETTER_ID_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ActionTypes.ATS_OFFER_LETTER_ID_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                offer_letter_id_data: action.payload?.data?.data?.[0] || {},
            };
        case ActionTypes.ATS_OFFER_LETTER_ID_GET_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        case ActionTypes.ATS_OFFER_LETTER_ID_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ActionTypes.ATS_OFFER_LETTER_ID_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                offer_letter_id_data: action.payload?.data?.data?.[0] || {},
            };
        case ActionTypes.ATS_OFFER_LETTER_ID_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
};

export default AtsOfferLetterIdReducer;
